import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import config from "../../../common/config";

export const solveService = createApi({
  reducerPath: "solve",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/users",
    prepareHeaders: (headers, { getState }) => {
      // Get token from Redux state
      const token = getState().authSlice?.token;
      
      // If we have a token, set the Authorization header
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSolveResult: builder.mutation({
      query: (formdata) => {
        const t0 = performance.now();
        return {
          url: "/logic/solve",
          method: "POST",
          body: formdata,
          responseHandler: async (response) => {
            const t1 = performance.now();
            console.log(`[PERF] /solve network+server: ${(t1 - t0).toFixed(1)} ms`);
            return response.json();
          }
        };
      },
    }),
    getVillainDecision: builder.mutation({
      query: (formdata) => {
        const t0 = performance.now();
        return {
          url: "/logic/villain-decision",
          method: "POST",
          body: formdata,
          responseHandler: async (response) => {
            const t1 = performance.now();
            console.log(`[PERF] /villain-decision network+server: ${(t1 - t0).toFixed(1)} ms`);
            return response.json();
          }
        };
      },
    }),
  }),
});
export const { useGetSolveResultMutation, useGetVillainDecisionMutation } = solveService;
